import React from "react";
import "./CustomLoaderBoxy.css";

const CustomLoaderBoxy = () => {
  return (
    <div className="loader">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default CustomLoaderBoxy;
